
import Vue from 'vue'
import CONF from '@/app.conf.json'
import {Util} from '../commons/util'

// Promise 垫片
require('core-js/fn/promise');


let Service = {

  /**
   * Promise request
   *
   * @param {String} url
   *        请求地址
   *
   * @param {Object} opts
   *        请求参数
   *
   * @retur Promise
   */
  reqPromise(url, opts) {

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {

        params: Util.removeFalseKeyInObject(opts)
      }).then(data => {
        if (data.body.code === '0') {

          resolve(data.body.data);
        } else if (data.body.code === '0001') {

          reject(new Error(`${url}接口参数错误`));
        } else if(data.body.code === '1'){

          // 没有数据
          resolve([]);
        } else {

          reject(new Error(`${url}接口错误`));
        }
      }, data => {

        reject(new Error(data));
      });
    });
  },

  /**
   * 查询 icon菜单展示
   *
   * @param {Number | String} type icon类型
   *        1：身边苏宁首页icon
   *        2：找服务icon
   *        3：我的（个人中心）icon
   *        4：苏宁帮客icon
   *
   * @return Promise
   */
  queryIconMenu(type) {

    let url = CONF.API.queryIconMenu,
      jsonpCallback = 'iconMenuCallback';

    url = url
      .replace('{{iconType}}', type)
      .replace('{{callback}}', jsonpCallback);

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url,{

        jsonpCallback: jsonpCallback
      }).then(data => {
        if (data.body.code === '0') {
          resolve(data.body);
        } else if (data.body.code === '0001') {
          reject(new Error(`${url}接口参数错误`));
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data));
      });
    });
  },

  /**
   * 查询服务站门店信息
   *
   * @params {String} storeCode
   *
   * @return Promise
   */
  queryStationStore(storeCode) {

    let url = CONF.API.storeInfo;

    url = url
      .replace('{{storeCode}}', storeCode)
      .replace('{{callback}}', 'queryStationStoreCallback');

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {

        jsonpCallback: 'queryStationStoreCallback'
      }).then(data => {
        if (data.body.code === '0') {

          resolve(data.body.data);
        } else if (data.body.code === '1') {
          resolve({});
        }else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data));
      });
    });
  },
  /**
   * 查询服务站广告图
   *
   * @params {String} storeCode
   *
   * @return Promise
   */
  queryStationBanner(cityCode) {

    let url = CONF.API.queryHomeAD;

    url = url
      .replace('{{cityCode}}', cityCode)
      .replace('{{id]}', '7')
      .replace('{{callback}}', 'queryStationBannerCallback');

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {

        jsonpCallback: 'queryStationBannerCallback'
      }).then(data => {
        if (data.body.code === '0') {

          resolve(data.body.data);
        } else if (data.body.code === '0005') {
          resolve([]);
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data));
      });
    });
  },
  /**
   * 查询服务站分类商品
   *
   * @params {String} storeCode
   *
   * @return Promise
   */
  queryStationProduct(storeCode, catelogId, pageNum) {

    let url = CONF.API.stationProduct;

    url = url
      .replace('{{storeCode}}', storeCode)
      .replace('{{catelogId}}', catelogId)
      .replace('{{pageNum}}', pageNum)
      .replace('{{callback}}', 'stationProductCallback');

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {

        jsonpCallback: 'stationProductCallback'
      }).then(data => {
        if (data.body.code === '0') {

          resolve(data.body.data);
        } else if (data.body.code === '0005') {
          resolve([]);
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data));
      });
    });
  },
  /**
   * 查询服务站简介
   *
   * @return Promise
   */
  queryStationInfo() {

    let url = CONF.API.stationInfo;

    url = url
      .replace('{{callback}}', 'stationInfoCallback');

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {

        jsonpCallback: 'stationInfoCallback'
      }).then(data => {
        if (data.body.code === '0') {

          resolve(data.body.data);
        } else if (data.body.code === '0005') {
          resolve('');
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data));
      });
    });
  }
};
export default Service;



// WEBPACK FOOTER //
// ./src/services/Station.js